/* global BX, arNextOptions */
import {closeBasket} from './open-basket-fly';

(function () {
    async function deleteProduct(event) {
        const button = event.target.closest('.remove');
        if (!button) return;
        const delayParent = button.closest('[item-section="DelDelCanBuy"]');
        const isDelayBtn = Boolean(delayParent);
        event.preventDefault();

        const itemBlock = button.closest('.basket-fly__item');
        if (!itemBlock) return;

        const productId = itemBlock.getAttribute('product-id') || itemBlock.dataset.productId;
        if (!productId) return;

        const basket = button.closest('.basket_fly, .basket-fly');
        let isLastItem = false;
        const itemDelay = basket?.querySelector('#basket_form [item-section="DelDelCanBuy"]');
        if (itemDelay) {
            isLastItem = itemDelay.querySelectorAll('.basket-fly__item').length === 1;
        }
        try {
            button.classList.add('is-loading');

            if (typeof window.delFromBasketCounter === 'function') {
                const needDelay = typeof window.checkCounters === 'function' ? window.checkCounters() : false;

                if (needDelay) {
                    window.delFromBasketCounter(productId);
                    await new Promise((r) => setTimeout(r, 120));
                } else {
                    window.delFromBasketCounter(productId);
                }
            }

            await fetch(`${arNextOptions.SITE_DIR}ajax/item.php?delete_item=Y&item=${productId}`, {
                method: 'GET',
                credentials: 'same-origin',
            });

            if (isLastItem && isDelayBtn) {
                const actualBasket = document.querySelector('.basket_fly, .basket-fly');
                if (actualBasket) {
                    closeBasket(actualBasket);
                }
            }
            if (window.BX?.onCustomEvent) {
                BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
            }
        } catch (e) {
            console.error('deleteProduct error:', e);
        } finally {
            if (button && document.contains(button)) {
                button.classList.remove('is-loading');
            }
        }
    }

    function init() {
        document.addEventListener('click', deleteProduct);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
